module.exports = __webpack_public_path__ + "img/cj_tip.ff5cbbda.png";